import RootState from 'typings/RootState'
import { Event } from 'Store/common/common.types'
import { ListData, TaxData, MerchantTaxData, AllCustomerTaxData } from './types'

export const selectTaxListEvent = (state: RootState): Event => state.taxReducer.listEvent

export const selectTaxList = (state: RootState): ListData => state.taxReducer.list

export const selectTaxActionEvent = (state: RootState): Event => state.taxReducer.actionEvent

export const selectTaxDetail = (state: RootState): TaxData | undefined => state.taxReducer.detail

export const selectTaxDetailEvent = (state: RootState): Event => state.taxReducer.detailEvent

export const selectMerchantTaxEvent = (state: RootState): Event => state.taxReducer.merchantTax.event

export const selectMerchantTaxData = (state: RootState): MerchantTaxData | undefined =>
  state.taxReducer.merchantTax.data

export const selectUpdateMerchantTaxEvent = (state: RootState): Event =>
  state.taxReducer.merchantTax.updateEvent

export const selectAllCustomerTax = (state: RootState): AllCustomerTaxData[] =>
  state.taxReducer.allCustomerTax
